import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import NoResults from '../containers/NoResults/NoResults';
import { withApplicationContext } from '../utils/ApplicationContext';
import { withLabels } from '../utils/LabelsContext';

const NoResult = ({ appCtx, searchTerm, labels }) => {
  useEffect(() => {
    appCtx.setBusy(false);
    appCtx.attachResizeListener();
  }, [searchTerm]);

  return (
    <NoResults
      appCtx={appCtx}
      title={labels.SEARCH_WITHOUT_RESULT_TITLE}
      description={labels.SEARCH_WITHOUT_RESULT_DESCRIPTION}
      term={searchTerm}
      regionCode={appCtx.regionCode}
    />
  );
};

NoResult.defaultProps = {
  appCtx: {},
  labels: {},
  searchTerm: PropTypes.string,
};

NoResult.propTypes = {
  searchTerm: PropTypes.string,
  appCtx: PropTypes.object,
  labels: PropTypes.object,
};

NoResult.getInitialProps = async (config, { query }) => {
  const searchTerm = query && query.Ntt ? encodeURIComponent(query.Ntt) : '';
  return { searchTerm };
};

export default withApplicationContext(withLabels(NoResult));
export { NoResult };
